import { Provider } from '@angular/core';
import { SadmGridDataService } from './services/sadm-grid-data.service';
import { SadmGridGalleryService } from './services/sadm-grid-gallery.service';
import { SadmGridHeaderActionsService } from './services/sadm-grid-header-actions.service';
import { SadmGridStore } from './services/sadm-grid-store';
import { SadmGridSaveService } from './services/sadm-grid-save.service';
import { SadmGridStoreBridgeService } from './services/sadm-grid-store-bridge.service';

export const provideSadmGrid = (): Provider[] => [
  SadmGridDataService,
  SadmGridSaveService,
  SadmGridStore,
  SadmGridStoreBridgeService,
  SadmGridGalleryService,
  SadmGridHeaderActionsService,
];
